/* ---------------------------------------------------------------
   Product buy box.

   Two jobs:

   1. The primary button reads "Add to bag · £118.00", so the price
      travels with the action. The theme's label comes from the locale
      file and carries no price, so it is composed here and kept in
      step with the variant.

   2. The colour row shows swatches only — four colour names in a row
      read as clutter. The selected colour is named in the row's label
      instead ("COLOUR — BLACK & WHITE"), which needs the name in an
      attribute the stylesheet can print.

   Note for whoever ships this: the word "bag" belongs in the locale
   file (the sticky bar already says Add to Bag, the main button says
   Add to Cart — they should agree). This script is the preview-stage
   fix, not the permanent home for it.
   --------------------------------------------------------------- */

(function () {
	var LABEL = 'Add to bag';
	var SOLD_OUT = /sold out|unavailable/i;

	function currentPrice(scope) {
		var sale = scope.querySelector('.price__sale .price-item--sale');
		var regular = scope.querySelector('.price__regular .price-item--regular');
		var any = scope.querySelector('.price-item');
		var el = sale || regular || any;
		return el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
	}

	function labelButton(form) {
		var button = form.querySelector('button[name="add"]');
		if (!button) return;

		var target = button.querySelector('span') || button;

		// leave the theme's own sold-out / unavailable wording alone
		if (SOLD_OUT.test(target.textContent.trim()) || button.disabled) return;

		var info = button.closest('.product__info-main') || document;
		var price = currentPrice(info);

		target.textContent = price ? LABEL + ' · ' + price : LABEL;
	}

	function labelColour(scope) {
		var container = scope.querySelector('.swatches__container');
		if (!container) return;

		var fieldset = container.closest('fieldset');
		if (!fieldset) return;

		var active = container.querySelector('.swatchs.active .color-value');
		var name = active ? active.textContent.trim() : '';

		if (name) {
			fieldset.setAttribute('data-selected-colour', name);
		} else {
			fieldset.removeAttribute('data-selected-colour');
		}
	}

	function init() {
		var scopes = document.querySelectorAll('.product__info-main');

		for (var i = 0; i < scopes.length; i++) {
			(function (scope) {
				labelColour(scope);

				var form = scope.querySelector('.product__buy_buttons .product-form');
				if (form) labelButton(form);

				if (scope.dataset.buyboxWatched === 'true') return;
				scope.dataset.buyboxWatched = 'true';

				// the price block and the button are both re-rendered on a
				// variant change, so watch the column rather than either
				var queued = false;
				var observer = new MutationObserver(function () {
					if (queued) return;
					queued = true;
					requestAnimationFrame(function () {
						queued = false;
						labelColour(scope);
						var f = scope.querySelector('.product__buy_buttons .product-form');
						if (f) labelButton(f);
					});
				});

				observer.observe(scope, { childList: true, subtree: true, characterData: true });
			})(scopes[i]);
		}
	}

	document.addEventListener('shopify:section:load', function () {
		var scopes = document.querySelectorAll('.product__info-main');
		for (var i = 0; i < scopes.length; i++) {
			delete scopes[i].dataset.buyboxWatched;
		}
		init();
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
